// extracted by mini-css-extract-plugin
export default {"container":"homeSection2Feature_container__T3wDX","section1":"homeSection2Feature_section1__YVO-7"};